import { Injectable } from '@angular/core';
import { XhrService } from '../../../core/services/xhr-service/xhr.service';
import { FindAllResellerResponseDto } from './reseller-map.interfaces';
import { API } from '../../../global/API.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResellerMapService {
  constructor(private xhr: XhrService) {}

  findAllReseller(): Observable<FindAllResellerResponseDto> {
    return this.xhr.get<FindAllResellerResponseDto>(API.resellerShop.findAll);
  }

  getCity(latitude: number, longitude: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(latitude, longitude);
      geocoder.geocode({ location: latlng }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            const add = results[0].formatted_address;
            const value = add.split(',');
            const count = value.length;
            const country = value[count - 1];
            const state = value[count - 2];
            const city = value[count - 3];
            resolve(city);
          }
        }
      });
    });
  }
}
